import { Injectable } from "@angular/core";
import { AbstractControl, ValidationErrors } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import * as _ from "lodash";

const ErrorsDict = {
  required: "app.validation.required",
  number: "app.validation.numerics",
  alphabets: "app.validation.alphabets",
  alphaNumeric: "app.validation.numeric_characters",
  maxLength: "app.validation.maxlength",
  minLength: "app.validation.minlength",
  validInput: "app.validation.validinput",
  netWeightError:"app.validation.validNetWeight",
  validEmail: "app.signup.email.validation"
};

@Injectable({
  providedIn: "root",
})
export class FormErrorValidationService {
  constructor(private translate: TranslateService) {}

  getErrors(errors: any) {
    if (errors) {
      const errorsArray: string[] = [];
      const regex_character = ["^[A-Z]*$", "^[a-z]*$"];
      const regex_numeric = "^[0-9]*$";
      const regex_alphaNumeric_ = "^[a-zA-Z0-9_\\-]*$";
      const regex_alphaNumeric = "^[a-zA-Z0-9]*$";
      const regex_email = '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$';


      if (errors.hasOwnProperty("required")) {
        errorsArray.push(ErrorsDict.required);
      }else if (errors.hasOwnProperty("weightError")) {
        errorsArray.push(ErrorsDict.netWeightError);
      } else if (errors.hasOwnProperty("minlength")) {
        errorsArray.push(
          `${this.translate.instant(ErrorsDict.minLength)}: ${
            errors.minlength.requiredLength
          }`
        );
      } else if (errors.hasOwnProperty("maxlength")) {
        errorsArray.push(
          `${this.translate.instant(ErrorsDict.maxLength)}: ${
            errors.maxlength.requiredLength
          }`
        );
      }else if (errors.hasOwnProperty("max")) {
        errorsArray.push(
          `Should be less than ${
            errors.max?.max
          }`
        );
      }else if (errors.hasOwnProperty("min")) {
        errorsArray.push(
          `Should be greater than ${
            errors.min?.min
          }`
        );
      }else if (errors.hasOwnProperty("pattern")) {
        const regexPattern = errors.pattern.requiredPattern;
        if (regexPattern && _.includes(regex_character, regexPattern)) {
          errorsArray.push(this.translate.instant(ErrorsDict.alphabets));
        } else if (
          regexPattern &&
          this.isPatternMatch(regex_numeric, regexPattern)
        ) {
          errorsArray.push(this.translate.instant(ErrorsDict.number));
        } else if (
          regexPattern &&
          this.isPatternMatch(regex_alphaNumeric_, regexPattern)
        ) {
          errorsArray.push(this.translate.instant(ErrorsDict.alphaNumeric));
        } else if (
          regexPattern &&
          this.isPatternMatch(regex_alphaNumeric, regexPattern)
        ) {
          errorsArray.push(this.translate.instant(ErrorsDict.alphaNumeric));
        } else if (
          regexPattern &&
          this.isPatternMatch(regex_email, regexPattern)
        ) {
          errorsArray.push(this.translate.instant(ErrorsDict.validEmail));
        } else {
          errorsArray.push(
            this.translate.instant((ErrorsDict.validInput))
          );
        }
      } else {
        errorsArray.push(this.translate.instant(ErrorsDict.validInput));
      }

      return errorsArray;
    } else {
      return [];
    }
  }

  isPatternMatch(str: string, pattern: string) {
    if (str == pattern) {
      return true;
    } else {
      return false;
    }
  }

  hasError(formCtrl: AbstractControl) {
    if (!formCtrl) {
      return false;
    }
    return formCtrl.errors && formCtrl.touched;
  }
}
